<template>
    <div class="task-list krs006">
        <div class="dashboard_box_grp clear">
            <div class="fl" id="folder">
                <div class="add_box" v-if="loginUserIsInternalUser && userInfo != null">
                    <button type="button" @click="registFolder">{{$i18nUtil.trans("entity.category.depth2.add","과정 추가")}}</button>
                </div> 
                <draggable
                  ghost-class="ghost"
                  v-model="list"
                  v-bind="dragOptions"
                  :move="onMove"
                  @end="endDragging"
                  class="folder_list"
                  v-if="showFolder" >
                    <div
                      class="card_grp hover_box"
                      v-for="(item , idx) in list"
                      :key="'folder_'+idx"  
                      :ref="`listFolder_`+item.category.categoryMid" ><!-- @mouseover=" categoryMenuForm=true "  -->
                        <div class="clear hover_inner"  ><!--  -->
                            <!-- <div class="move"></div> -->
                            <div class="subject" :class="getClassName(item)" @click="showBoardList(item.category, idx, $event)" ><!-- @click="showBoardList(item.category, idx, $event)"-->
                              <div class="ell-singleline" style="min-width:126px;"
                                @mouseover="mouseEvt(true, item, $event, 'category')"
                                @mouseleave="mouseEvt(false, item, null, 'category')"
                              >
                                {{ item.category.categoryName }}
                              </div>
                              <!-- <form action=""> 
                                <div class="input-box">
                                      <input type="text"  required placeholder="명을 입력하세요" disabled maxlength="12">
                                      <button type="reset" class="input-txt-del">입력 삭제</button>
                                </div>
                              </form> -->
                            </div>
                            <div class="tooltip-b tl small" :id="item.category.categoryMid+'_tooltip'" style="display:none; z-index: 10; line-height: normal; margin-top: 13px;">
                              {{ item.category.categoryName }}
                            </div> 

                            <div class="droplayer icon more right nosel" v-if="( checkManager(item) )&& selectedFolderIndex == idx" >
                                                                      <!-- userInfo != null && selectedFolderIndex == idx-->
                                <v-menu bottom left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" >더보기</v-btn>
                                    </template>
                                    <div class="dropdown-list">
                                        <div class="dropdown-list-item"><div class="tit"><button type="button" @click.stop="updateFolderName(item)">{{$i18nUtil.trans("title.RegistCategoryModal.002", "과정명 변경")}}</button></div></div>
                                        <div class="dropdown-list-item"><div class="tit"><button type="button" @click.stop="deleteFolder(item,idx)">{{$i18nUtil.trans("title.DeleteFolderAlert.001", "과정 삭제")}}</button></div></div>
                                    </div>
                                </v-menu>
                            </div>

                            <!-- <dl class="more_box small right" > 
                                <dt class=""><button type="button" class="more" @click.stop="$event.target.parentElement.classList.toggle('active');">더보기</button></dt>
                                <dd>
                                    <ul style="width: 100px;"> 
                                        <li><button type="button" @click.stop="updateFolderName(item)"> 이름변경</button></li>
                                        <li><button type="button" @click.stop="deleteFolder(item,idx)"> 삭제</button></li>
                                        <li><button type="button" @click.stop="addBoard(item)" >업무보드 추가</button></li>
                                    </ul>
                                </dd>
                            </dl> -->

                        </div>
                    </div>
                </draggable>
            </div>

            <div class="output_grp"  :style="{ 'min-height' : dBHeight+25+ 'px'}">
                <div class="output_tit">
                    <div class="tit" style="word-break: break-all;">{{selectedFolder.categoryName}}</div>
                </div>

                <div class="tb-list_ty1">
                    <div class="tb-header clear">
                        <div class="tb_num fl">
                            <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
                            <!-- 검색 조회시 노출 S -->
                            <div class="check_result" v-show="showSearchBoardTitle">
                                <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchPaperTitle, cnt: totalElements})"></div>
                                <button type="button" @click="clearSearchPaperTitle">초기화</button>
                            </div>
                            <!-- //검색 조회시 노출 E -->
                        </div>

                        <div class="tb_sort fr">
                            <input v-if="tenantId != '203'" type="checkbox" name="" id="chkReadFilter" v-model="isReadFilter" @change="fireFilterRead"><label v-if="tenantId != '203'" for="chkReadFilter">{{ $i18nUtil.trans("button.paper.unread", "미확인 보드 보기") }}</label>
                            <input type="checkbox" name="" id="chkBookmarkFilter" v-model="isBookmarkFilter" @change="fireFilterBookmark"><label for="chkBookmarkFilter">{{ $i18nUtil.trans("button.favorite", "즐겨찾기 보기") }}</label>
                            <div class="dividing_line_ty1"></div>
                            <div class="search_ty2">
                                <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                                <form action="" @submit.prevent="false == false" onsubmit="return false;" class="search-show">
                                  <div class="input-box">
                                    <input type="text" 
                                      class="search-show" 
                                      :class="searchPaperTitle == '' ? 'ico_search' : ''" 
                                      v-model="searchPaperTitle" 
                                      @keyup.enter="getListTabDashboardBoardList(null, true)"
                                      :placeholder="$i18nUtil.trans('message.placeholder.boardName','보드명 검색')"
                                      @focus="$event.target.placeholder=''"
                                      @focusout="$event.target.placeholder=$i18nUtil.trans('message.placeholder.boardName','보드명 검색')"
                                      maxlength="21"
                                    />
                                    <button type="reset" 
                                      class="input-txt-del search-show" 
                                      @click="searchPaperTitle = ''" 
                                      v-if="searchPaperTitle != ''"
                                    >
                                      입력 삭제
                                    </button>
                                    <button type="reset" 
                                      class="btn_search search-show" 
                                      @click="getListTabDashboardBoardList(null, true)"
                                    >
                                      검색
                                    </button>
                                  </div>
                                </form>
                            </div>
                            <CommonFilterE :filterReset="filterReset" @updateCommonFilterE="updateCommonFilterE" :initFilter="initFilter"/>
                            <!-- <div class="droplayer icon filter-box board-list-e relative">
                              <v-menu offset-y :close-on-content-click="false">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on" class="sel">필터</v-btn>
                                  </template>
                                  <div class="dropdown-list cnt board">
                                      <div class="cnt_inner clear">
                                          <div class="cnt-option">
                                              <div class="tit">상세 옵션</div>
                                              <ul>
                                                <li class="active" @click="filterCntOption($event, 'ALL')"><button type="button">전체공개</button></li>
                                                <li @click="filterCntOption($event, 'MY')"><button type="button">내가 생성한</button></li>
                                                <li @click="filterCntOption($event, 'MEMBER')"><button type="button">멤버만공개</button></li>
                                              </ul>
                                          </div>
                                          <div class="cnt-evaluation">
                                              <div class="tit">상태</div>
                                              <ul>
                                                <li class="active" @click="filterPaperStatus($event, 'ALL')">
                                                  <button type="button" class="all">진행상태전체</button>
                                                </li>
                                                <li @click="filterPaperStatus($event, 'GOOD')"><button type="button" class="ico-txt-evaluate-good">{{$i18nUtil.trans('entity.paper.paperStatus.GOOD','정상')}}</button></li>
                                                <li @click="filterPaperStatus($event, 'SO')"><button type="button" class="ico-txt-evaluate-so">{{$i18nUtil.trans('entity.paper.paperStatus.SO','이슈 발생')}}</button></li>
                                                <li @click="filterPaperStatus($event, 'DELAY')"><button type="button" class="ico-txt-evaluate-delay">{{$i18nUtil.trans('entity.paper.paperStatus.DELAY','보고 필요')}}</button></li>
                                                <li @click="filterPaperStatus($event, 'EXCEEDED')"><button type="button" class="ico-txt-evaluate-exceeded">{{$i18nUtil.trans('entity.paper.paperStatus.EXCEEDED','종료')}}</button></li>
                                              </ul>
                                          </div>
                                          <div class="cnt-editor">
                                              <div class="tit">생성/수정자</div>
                                              <ul>
                                                <li>
                                                  <input type="checkbox" name="" 
                                                    id="chkUpdUserIdAll" 
                                                    checked
                                                    v-model="allSelectedUpdUser"
                                                    @click="selectAllUpdUser"
                                                  >
                                                  <label for="chkUpdUserIdAll">전체</label>
                                                </li>
                                                <li 
                                                  v-for="(updUserItem, updUserIndex) in updUserList"
                                                  :key="updUserItem.lastUpdUserId + '_' + updUserIndex"
                                                >
                                                  <input type="checkbox" name="" 
                                                    :id="`chkUpdUserId`+updUserIndex" 
                                                    v-model="updUserIds"
                                                    :value="updUserItem.lastUpdUserId"
                                                    @change="checkUpdUserFilter"
                                                  >
                                                  <label :for="`chkUpdUserId`+updUserIndex">{{updUserItem.lastUpdUserName}}</label>
                                                </li>
                                              </ul>
                                          </div>
                                      </div>
                                      <div class="info">필터는 중복 선택이 가능합니다.</div>
                                  </div>
                              </v-menu>
                            </div> --> 
                        </div>
                    </div><!-- //tb-header -->

                    <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="boardListFilter"
                      :page.sync="page"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :must-sort="true"
                      :items-per-page="itemsPerPage"
                      :server-items-length="totalElements"
                      hide-default-footer
                      class="tb-contents ins002a">
                        <template v-slot:item="{ item }">
                            <tr :class="item.isState">
                            <td class="division">
                                <div type="button" :class="getEvaluateClassAndText(item).evaluateClass">
                                    {{getEvaluateClassAndText(item).evaluateText}}
                                </div>
                                <div class="subject ell-multiline2" @click="goBoard(item)">{{ item.paperTitle }}</div>
                                <UserInfo 
                                  :userId="item.regUserId" 
                                  :userName="item.regUserName" 
                                  :userNameEn="item.regUserNameEn"
                                  :userCount="item.paperUserCount" 
                                  :paperId="item.paperId" 
                                  :isLinkedBoard="item.paperProjectLinkId != null"
                                />
                                <div class="dividing_line_ty3"  v-if="item.paperProjectLinkId != null"></div>
                                <div class="txt-linked ell-singleline" style="cursor: pointer;" @click="moveProject(item.linkProjectId)" v-if="item.paperProjectLinkId != null"
                                  @mouseover="mouseEvt(true, item, $event, 'linked')"
                                  @mouseleave="mouseEvt(false, item, null, 'linked')"
                                >
                                  Linked : {{item.linkProjectName}}
                                  <div class="tooltip-b tl small" :id="item.linkProjectId+'_tooltip'" style="display:none; z-index: 10; position:absolute;">
                                    {{ item.linkProjectName }}
                                  </div>
                                </div>
                            </td>
                            <td class="txtc">
                                <button 
                                  type="button" 
                                  class="ico-switch_favorites small active" 
                                  v-show="item.paperBookmarkId != null" 
                                  @click="toggleBookmark(item)"
                                >
                                  즐겨찾기
                                </button>
                                <button 
                                  type="button" 
                                  class="ico-switch_favorites small" 
                                  v-show="item.paperBookmarkId == null"
                                  @click="toggleBookmark(item)"
                                >
                                  즐겨찾기
                                </button>
                            </td>
                            <td class="feedback txtc">
                                <span class="ico-txt_comment" v-if="item.commentCount < 1000">{{ item.commentCount }}</span>
                                <span class="ico-txt_comment" v-else-if="item.commentCount > 999">999+</span>
                            </td>
                            <td class="date txtc">
                              <!-- 24시간 이내-->
                              <momentAgo v-if="checkHours(item.lastUpdDate)" prefix="" suffix="전" :date="item.lastUpdDate" lang="kr"></momentAgo>
                              <!-- 24시간 이후-->
                              {{ !checkHours(item.lastUpdDate) ? replaceAll(item.lastUpdDate.substring(0, 10), "-", ".") :''}}
                              <!-- {{ !checkHours(item.lastUpdDate) ? item.lastUpdDate.substring(0,10).replaceAll("-", ".") : '' }} -->
                              <span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
                              <!-- {{ item.update }} <span :class="item.icoNew"></span> -->
                            </td>
                            <td class="author txtc">
                              <div class="droplayer tooltipmember relative right">
                                <v-menu offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on">
                                      <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastUpdUserName : item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</b>
                                    </v-btn>
                                  </template>
                                  <div class="dropdown-list">
                                    <UserTooltip
                                      :userId="item.lastUpdUserId"
                                    />
                                  </div>
                                </v-menu>
                              </div>
                            </td>
                            <td class="txtc">
                              <div class="droplayer icon more right nosel">
                                  <v-menu bottom left>
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" @click="checkInOut($event, item, on, attrs)">더보기</v-btn>
                                      </template>
                                      <div class="dropdown-list">
                                          <div class="dropdown-list-item hidden"><div class="tit"><button type="button" @click="openPaperNewWindow(currentURL(),item);">{{ $i18nUtil.trans("button.paper.open.newWindow", "새 창으로 보기") }}</button></div></div>
                                          <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="infoShareReqPost(item);">{{ $i18nUtil.trans("title.ReqPostModal.shareInfo", "정보공유 게시") }}</button></div></div>
                                          <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="cooperationReqPost(item)">{{ $i18nUtil.trans("title.ReqPostModal.cooperation", "회의/협의 게시") }}</button></div></div>
                                          <div class="dropdown-list-item hidden"><div class="tit"><button type="button" @click="copyURL(currentURL(),item)">{{ $i18nUtil.trans("button.paper.copy.url", "보드 URL 복사") }}</button></div></div>
                                          <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null && tenantId != '203'"><div class="tit"><button type="button" @click="copyPaperModal(item)">{{ $i18nUtil.trans("button.paper.copy", "보드 복제") }}</button></div></div>
                                          <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="deleteBoard(item)">{{ $i18nUtil.trans("button.paper.delete", "보드 삭제") }}</button></div></div>
                                          <div 
                                            class="dropdown-list-item" 
                                            v-if="item.paperProjectLinkId != null && (isProjectManager || item.linkRegUserId == userId)">
                                            <div class="tit">
                                              <button type="button" @click="unlinkedProject(item)">
                                                {{ $i18nUtil.trans("button.project.unLinked", "Linked 연결 해제") }}
                                              </button>
                                            </div>
                                          </div>
                                      </div>
                                  </v-menu>
                              </div> 
                            </td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="nodata-txt-noicon" v-if="!showSearchBoardTitle && !isSearchKeywordFlag">
                              <v-alert :value="true">
                                  {{ $i18nUtil.trans("message.DashboardList.001","과제 보드를 등록하여 멤버들과 협업해보세요.") }}
                              </v-alert>
                              <button v-if="list.length != 0" type="button" class="btn-primary-small black" :disabled="!loginUserIsInternalUser" @click="addBoard(null)">{{$i18nUtil.trans("button.paper.pro.add", "과제 보드 추가")}}</button>
                            </div>
                            <div class="nodata-txt-noicon" v-else>
                              <v-alert :value="true">
                                  {{ $i18nUtil.trans("search.007", "조회된 결과가 없습니다.") }} <!-- 조회된 결과가 없습니다. -->
                              </v-alert>
                            </div>
                        </template>
                      </v-data-table>

                      <div class="pagination">
                      <v-pagination
                          v-model="page"
                          circle
                          :length="pageCount"
                          :total-visible="7"
                      ></v-pagination>
                    </div>
                </div><!-- //tb-list_ty1 -->

            </div><!--//output_grp-->
            </div>

            
            
        </div>
   
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import draggable from 'vuedraggable'
import RegistCategoryModal from "../../../modal/RegistCategoryModal";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import reqPost from "../../../modal/ReqPostModal";
import CopyBoardModal from "@/components/cowork/general/board/modal/CopyBoardModal";
import axios from 'axios';
import Vue from 'vue';
import ConfirmModal from "../../../modal/ConfirmModal"; 
import UserInfo from "@/components/cowork/common/user/UserInfo";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import CommonFilterE from "@/components/cowork/common/filter/CommonFilterE";

let id = 1;

export default {
    name: "simple",
    display: "Simple",
    order: 0,
    components: {
        draggable,
        RegistCategoryModal,
        UserInfo,
        UserTooltip,
        CommonFilterE
    },
    props:["projectName", "publicYn","loginUserIsInternalUser"],
    data() {
      return {
        dBHeight:null,

        showFolder: true,
        userId:"",
        userInfo:null,

        selectedFolderIndex:0,

        projectId:null,
        groupId:null,
        iList:[],
        eList:[],

        section:'IDEATION',
        // projectId:null,
        categoryName:'', 
        isDragging: false,
        delayedDragging: false, 
        relatedContext:null,
        draggedContext:null,

        categoryMenuForm:false,

        enabled: true,
        showSearchBoardTitle: false,
        isSearchKeywordFlag: false,
        page: 1,
        pageCount: 0,
        selected: [],
        itemsPerPage: 10,
        isBookmarkFilter: false,
        isReadFilter: false,
        searchPaperTitle: '',
        rtnSearchPaperTitle: '',
        isSearchArea: false,
        list: [],
        headers: [
            { text: this.$i18nUtil.trans("entity.paper.filter.paperTitle","보드명"), align: 'center', value: 'paperTitle', sortable: true },
            // { text: '보드명', align: 'center', value: 'paperTitle', sortable: false },
            { text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), value: 'paperBookmarkId', sortable: false },
            { text: this.$i18nUtil.trans("entity.paper.filter.comment","의견/답변"), value: 'commentCount', sortable: true},
            // { text: '의견/답변', value: 'commentCount', sortable: false},
            { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트"), value: 'lastUpdDate', sortable: true },
            // { text: '마지막 업데이트', value: 'lastUpdDate', sortable: false },
            { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), value: 'lastUpdUserName', sortable: true },
            // { text: '생성/수정자', value: 'lastUpdUserName', sortable: false },
            { text: this.$i18nUtil.trans("entity.paper.filter.more","더보기"), value: 'more', sortable: false },
        ],
        boardList: [],
        boardListFilter: [],
        selectedFolder: {},
        updUserList: [],
        allSelectedUpdUser: true,
        updUserIds: [],
        folderIds: [],
        allSelectedFolder: true,
        selectedCntOption: 'ALL',
        selectedEvaluationOption: 'ALL',
        selectedPaperStatus: 'ALL',

        toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
            position: "bottom-left",
            duration: 3000,
          },
        },

        categoryListInfo:null,
        parentCategoryMid:null,

        isProjectManager: false,
        /* 정렬 */
        totalElements: 0,
        sortBy: ['lastUpdDate'],
        sortDesc: [true],
        /* 페이지 변경 또는 정렬 이벤트시 */
        changeTableData: false,
        gradeCodeList: [],
        statusList: [],
        filterReset: true,
        initFilter:[],
        gradeCheckYn : false,
        statusCheckYn : false,

        defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko',

        tenantId : localStorage.getItem("tenantId"),
      };
    },
    watch:{
      projectMemberList(){
        let obj = this;
        this.projectMemberList.forEach(function(user){ 
          if(user.userId == obj.userId ){ 
            obj.userInfo = user;
          }
        }) 
      },
      page: {
        handler() {
          if(this.changeTableData != true) {
            this.changeTableData = true;
          }
          window.scrollTo(0, 0);
        }
      },
      sortBy: {
        handler() {
          if(this.changeTableData != true) {
            this.changeTableData = true;
          }
        }
      },
      sortDesc: {
        handler() {
          if(this.changeTableData != true) {
            this.changeTableData = true;
          }
        }
      },
      changeTableData: {
        handler() {
          let obj = this;
          if(obj.changeTableData == true){
            setTimeout(()=>{
              obj.changeTableData = false;
              obj.getListTabDashboardBoardList(obj.selectedFolder, false);
            }, 500);
          }
        },
        deep: true
      },
    }, 
    mounted(){ 
      const self = this;
      $("html").click(function (e) {
        if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
            self.isSearchArea = false;
        }
      });
    },
    computed: { 
      ...mapState("project", ["projectInfo"]), // 현재 정보
      ...mapState("project", ["projectMemberList"]), // 현재 멤버정보
      draggingInfo() {
          return this.dragging ? "under drag" : "";
      },
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost",
        };
      }
    },
    methods: {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
      ...mapActions("modals", ["showModal", "showToast"]),
      ...mapMutations("project", ["setSelectedFolder"]), 

      /* 툴팁 */
      mouseEvt(flag, item, event, type) {
        let tooltipId = type === 'category' ? item.category.categoryMid+'_tooltip' : item.linkProjectId+'_tooltip';

        if(flag) {
          // 말줄임(...) css 적용 여부 체크 (boolean)
          let val = type === 'category' ? this.$tooltip.hasOverflownWidth(event.target) : this.$tooltip.hasOverflownWidthRemoveClass(event.target, "ell-singleline")
          if(val) {
            document.getElementById(tooltipId).style.display = 'block';
          }else{
            document.getElementById(tooltipId).style.display = 'none';
          };
        }else{
          document.getElementById(tooltipId).style.display = 'none';
        }
      },
      checkInOut(event, item, on, attrs){   
        let obj =this;

        // if( ( !this.loginUserIsInternalUser ||  this.userInfo == null ) && event.isTrusted){
        //   event.target.click();
        //   obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
        //   obj.showToast(obj.toastInfo);
        // }
        if(item != null && item != undefined) {
          
          if(attrs["aria-expanded"] == "false") {
            let param = {
              url: '/api/copaper/paper/getPaperAuth',
              method: 'post',
              req: {
                paperId: item.paperId,
                checkRoleId: 'NOR_BRD_WRITE:false|NOR_BRD_COPY|NOR_BRD_DELETE|NOR_BRD_READ',
                isCheckInternalUser: true,
              }
            };
            //프로그레스바 시작 
            
            // obj.showLoadingbar();
            obj.COWORK_REST_ACTION(param)
            .then(function (res) {
            //프로그레스바 종료
            // obj.hideLoadingbar();
            if(res.errorCode == null) {
              // 내부직원/외부직원
              let isInternalUserFlag = res.result.isInternalUser;
              let cfrcUse = res.result.isCfrcUse;
              let sharUse = res.result.isSharUse;
              
              // 0: 쓰기 권한
              // 1: 복제 권한
              // 2: 삭제 권한
              // 3: 읽기 권한
              let paperAuthList = res.result.paperAuthList;
              
              let moreItemList = event.target.parentElement.lastChild.firstChild.lastChild.children;
              if(moreItemList && moreItemList.length > 0) {
                // 정보공유/회의협의 게시 권한없음 토스트 알림 뜨도록 설정
                item.checkPostYn = true;

                let newWindowText = obj.$i18nUtil.trans("button.paper.open.newWindow", "새 창으로 보기");
                let sharePostText = obj.$i18nUtil.trans("title.ReqPostModal.shareInfo", "정보공유 게시");
                let cfrcPostText = obj.$i18nUtil.trans("title.ReqPostModal.cooperation", "회의/협의 게시");
                let boardUrlCopyText = obj.$i18nUtil.trans("button.paper.copy.url", "보드 URL 복사");
                let copyBoardText = obj.$i18nUtil.trans("button.paper.copy", "보드 복제");
                let deleteBoardText = obj.$i18nUtil.trans("button.paper.delete", "보드 삭제");
                for (let mItem of moreItemList) {
                  // 임직원
                  if(isInternalUserFlag) {
                    // 전체공개
                    if(obj.projectInfo.cogroup.publicYn == 1) {
                      // 새 창으로 보기
                      if(mItem.textContent == newWindowText && paperAuthList[3]["allow"]) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      // 정보공유 게시 (2021.03.30 정보공유, 회의/협의 분리)
                      else if(mItem.textContent == sharePostText && sharUse) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 보드 멤버인 경우만
                        if(paperAuthList[0]["allow"]) {
                          // 토스트 안뜨고 레이어 뜨도록 설정
                          item.checkPostYn = false;
                        }
                        // // 멤버
                        // else {
                        //   // 전체공개 > 전체공개보드의 경우
                        //   if(item.docGrade == "NORMAL") {
                        //     if(mItem.classList.contains("hidden")) {
                        //       mItem.classList.remove("hidden");
                        //     }
                        //   }
                        // }
                      } 
                      // 회의/협의 게시
                      else if(mItem.textContent == cfrcPostText && cfrcUse) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 보드 멤버인 경우만
                        if(paperAuthList[0]["allow"]) {
                          // 토스트 안뜨고 레이어 뜨도록 설정
                          item.checkPostYn = false;
                        }
                      }
                      // 보드 URL 복사
                      else if(mItem.textContent == boardUrlCopyText) {
                        // 권한없음 토스트 뜨지 않도록 설정
                        item.checkUrlBoardFlag = false;
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 운영자/보드 생성자/멤버/보드멤버/전체공개 > 전체공개보드
                        if(!paperAuthList[0]["allow"]) {
                          // 권한없음 토스트 뜨도록 설정
                          item.checkUrlBoardFlag = true;
                        }
                      }
                      // 보드 복제 권한체크
                      else if(mItem.textContent == copyBoardText) {
                        if(!mItem.classList.contains("hidden")) {
                          mItem.classList.add("hidden");
                        }
                        if(paperAuthList[1]["allow"]) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      // 보드 삭제 권한체크
                      else if(mItem.textContent == deleteBoardText) {
                        if(!mItem.classList.contains("hidden")) {
                          mItem.classList.add("hidden");
                        }
                        if(paperAuthList[2]["allow"] && item.regUserId == obj.projectInfo.loginUserId) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      
                    }
                    // 멤버만 공개
                    else {
                      // 새 창으로 보기
                      if(mItem.textContent == newWindowText && paperAuthList[3]["allow"]) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      // 정보공유 게시 (2021.03.30 정보공유, 회의/협의 분리)
                      else if(mItem.textContent == sharePostText && sharUse) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 보드 멤버인 경우만
                        if(paperAuthList[0]["allow"]) {
                          // 토스트 안뜨고 레이어 뜨도록 설정
                          item.checkPostYn = false;
                        }
                        // // 멤버
                        // else {
                        //   // 전체공개 > 전체공개보드의 경우
                        //   if(item.docGrade == "NORMAL") {
                        //     if(mItem.classList.contains("hidden")) {
                        //       mItem.classList.remove("hidden");
                        //     }
                        //   }
                        // }
                      }
                      // 회의/협의 게시
                      else if(mItem.textContent == cfrcPostText && cfrcUse) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 보드 멤버인 경우만
                        if(paperAuthList[0]["allow"]) {
                          // 토스트 안뜨고 레이어 뜨도록 설정
                          item.checkPostYn = false;
                        }
                      }
                      // 보드 URL 복사
                      else if(mItem.textContent == boardUrlCopyText) {
                        // 권한없음 토스트 뜨지 않도록 설정
                        item.checkUrlBoardFlag = false;
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        //  운영자/보드 생성자/멤버/보드멤버/전체공개  > 전체공개보드
                        if(!paperAuthList[3]["allow"]) {
                          // 권한없음 토스트 뜨도록 설정
                          item.checkUrlBoardFlag = true;
                        }
                      }
                      // 보드 복제 권한체크
                      else if(mItem.textContent == copyBoardText) {
                        if(!mItem.classList.contains("hidden")) {
                          mItem.classList.add("hidden");
                        }
                        if(paperAuthList[1]["allow"]) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      // 보드 삭제 권한체크
                      else if(mItem.textContent == deleteBoardText) {
                        if(!mItem.classList.contains("hidden")) {
                          mItem.classList.add("hidden");
                        }
                        if(paperAuthList[2]["allow"] && item.regUserId == obj.projectInfo.loginUserId) {
                          mItem.classList.remove("hidden");
                        }
                      }
                    }
                    
                  }
                  // 외부직원
                  else {
                    // 전체공개
                    if(obj.projectInfo.cogroup.publicYn == 1) {
                      // 보드 URL 복사
                      if(mItem.textContent == newWindowText) {
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                      }
                      // 보드 URL 복사
                      else if(mItem.textContent == boardUrlCopyText) {
                        // 권한없음 토스트 뜨지 않도록 설정
                        item.checkUrlBoardFlag = false;
                        if(mItem.classList.contains("hidden")) {
                          mItem.classList.remove("hidden");
                        }
                        // 외부 직원 : 읽기 권한 없을 경우
                        if(!paperAuthList[3]["allow"]) {
                          // 권한없음 토스트 뜨도록 설정
                          item.checkUrlBoardFlag = true;
                        }
                      } 
                      else {
                        if(!mItem.classList.contains("hidden")) {
                          mItem.classList.add("hidden");
                        }
                      }
                    }
                    // 멤버만 공개
                    else {
                      if(!mItem.classList.contains("hidden")) {
                        mItem.classList.add("hidden");
                      }
                    }
                  }
                }
              }
            }
            })
            .catch(function (err) {
              console.log(err);
            });
          }
        }
      },
      setprojectIdAndGroupId(projectId, groupId, userId, state, targetFolderItem){ 
        let obj = this;
        obj.boardList = [];
        obj.boardListFilter =[];
        
        // hyej 
        if(sessionStorage.getItem("dashboard") != undefined || sessionStorage.getItem("dashboard") == "") {
          let selected = JSON.parse(sessionStorage.getItem("dashboard"));
          for(var i=selected.length; i>=0; i--) {
            let select = selected[i];
            if(select != undefined && select.categoryMid != undefined) {
              if(select.projectId != undefined && select.projectId == obj.$route.params.projectId) {
                // 보드에서 뒤로가기로 과제/협업공간 에 왔을 떼, 보드로 이동 전의 과정/폴더 select
                targetFolderItem = select;
                break;
              }else {
                // 새탭에서 다른 과제로 화면 이동 후, 원탭에서 데이터가 일치하지 않는 경우 발생하여 추가
                // (과제(proj2) 화면에서 이전 과제(proj1) 보드 목록이 보임)
                // 보고 있는 보드가 속한 과제로 이동
                obj.$router.replace(`/general/dashboard/${select.projectId}`)
                return ;
              }
            }
          }
        }

        this.userId = userId;
        this.projectMemberList.forEach(function(user){ 
          if(user.userId == obj.userId ){ 
            obj.userInfo = user;
          }
        })
        this.projectId= projectId;
        this.groupId = groupId; 
        this.selectedFolderIndex = 0;
        // this.initFolder(targetFolderItem||null);
        this.gradeCodeList = [];
        this.statusCodeList = [];
        this.filterReset = true;
        setTimeout(()=>{this.filterReset = false;}, 50);
        if(window.sessionStorage.getItem("moveBoard") === 'true'){
          // window.sessionStorage.setItem("moveBoard",false);
          this.initFolder(targetFolderItem||null);
        }else{
          let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          if(stateArr.length == 0){
            //저장
            stateArr.push(state);
            window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
          }else{
            let lastState = stateArr[stateArr.length-1];
            let localStorageAllListYn  = localStorage.getItem("boardAllListUse");
            if(localStorageAllListYn === "true"){
              if(lastState.currentTab == 0 && lastState.currentTab2 == 1 && lastState.currentTab3 == 0){
                // 같은 탭 누른 경우 .
              }else{
                // 다른 탭에서 누른경우
                stateArr.push(state);
                window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
              }
            }else{
              if(lastState.currentTab == 0 && lastState.currentTab2 == 0 && lastState.currentTab3 == 0){
                // 같은 탭 누른 경우 .
              }else{
                // 다른 탭에서 누른경우
                stateArr.push(state);
                window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
              }
            }
          }
          if(window.sessionStorage.getItem("prevBtn")  === 'true' ){ 
            // 뒤로가기 버튼으로 접근.
            this.initFolder(state||null); 
          }else{
            this.initFolder(targetFolderItem||null); 
          }
        }
      },
      initFolder(targetFolderItem){
        let obj = this;
        let reqData = {};
        reqData.params = {
          projectId: this.projectId,
        };
        reqData.req = obj.req;
        // reqData.url = "/api/copaper/category/getDashboardCategoryList";
        reqData.url = "/api/copaper/category/getProjectCategoryList";
        reqData.method = "post"; 
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => { 
            // this.iList = res.result.categoryList[0];
            // this.eList = res.result.categoryList[1]; 

            this.list=[];
            this.showFolder = false;
            this.showFolder = true;
            this.selectedFolder = {};
            this.boardListFilter = [];
            this.boardList = [];
            this.updUserList = [];
            this.updUserIds = [];
            this.folderIds = [];
            this.list = res.result.categoryList.list; 
            this.categoryListInfo = res.result.categoryList.info;
            this.parentCategoryMid = res.result.categoryList.parentCategoryMid;
            this.showFolder = false;
            this.showFolder = true;

            this.list.forEach(function(data){
              data.category.paperCount = data.paperCount;
            })

            if(targetFolderItem != null){
              if(this.list != null && this.list.length > 0) {
                let targetFolderIndex = -1;
                this.list.forEach((fol, folIdx) => {
                  if(fol.category.categoryMid == targetFolderItem.categoryMid) {
                    targetFolderIndex = folIdx;
                  }
                });
                if(targetFolderIndex != -1) {
                  this.showBoardList(this.list[targetFolderIndex].category, targetFolderIndex);
                }
              }
            }
            else if(this.list.length != 0){ 
              this.setSelectedFolder(this.list[this.selectedFolderIndex].category);
              this.showBoardList(this.list[this.selectedFolderIndex].category, this.selectedFolderIndex);
            }

            this.$emit("folderLength",this.list.length,this.parentCategoryMid); 
 
            this.$nextTick(function(){ 
              obj.dBHeight =document.getElementById('folder');//
              if(obj.dBHeight != null){
                obj.dBHeight = document.getElementById('folder').clientHeight
              }
            })
             
          })
          .catch(function (err) {
            console.log(err);
          });

        
      },
      addBoard(item) {
        
        let obj = this;
        let reqData = {};
        reqData.params ={
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/paper/getGeneratedPaperId";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            let errorCode = res.errorCode;
            let addPaperId = res.result;
            const modalInfo = {
              title: obj.$i18nUtil.trans("title.RegistBoardModal.000", "업무보드 추가"),
              name: "registBoard",
              method: "post",
              width: "800px",
              // height: "493px",
              obj: obj.$modal,
              paperId: addPaperId, 
              categoryMid: item != null ? tem.categoryi.categoryMid : this.selectedFolder.categoryMid,
              groupId:  obj.groupId || item.category.groupId, 
              projectId: obj.projectId || obj.$route.item.category.projectId,
              projectName:this.projectName,
              paperTitle: "",
              contentPath: "",
              docGrade: String(this.publicYn) == "1" ? "NORMAL" : "RESTRICT",
              component: RegistBoardModal,
              //localselectIidx: obj.localselectIidx,
              parentCategoryMid: item != null ? item.category.parentCategoryMid : this.parentCategoryMid
            };
            obj.showModal(modalInfo);
          })
          .catch(function(err) {
            console.log(err);
          });
      },
       //drag
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element; // 같은 열에서 움직일때 변화되는 data (클릭해서 움직이는 데이터 X 밀리는데이터 O)
        const draggedElement = draggedContext.element; // 클릭해서 움직이는 data
        this.relatedContext=relatedContext;
        this.draggedContext=draggedContext;
        
      },
      endDragging(){
        if(this.relatedContext == null || this.draggedContext == null){
        }else{
          let obj = this;
          let reqData = {};
          reqData.params ={
            groupId : this.draggedContext.element.category.groupId, 
            categoryMid : this.draggedContext.element.category.categoryMid,         // 드래그로 옮겨지는 애               
            beforeSortNo : this.draggedContext.element.category.sortNo,             // 드래그로 옮겨지는 애
            pushedCategorySortNo: this.relatedContext.element.category.sortNo,      // 밀리는 애
            pushedCategoryMid:this.relatedContext.element.category.categoryMid,    // 밀리는 애
          }
        
          reqData.req = obj.req;
          reqData.url = "/api/copaper/category/moveCategorySort";
          reqData.method = "post";
          obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
            })
            .catch(function(err) {
              console.log(err);
            });
        }
      },
      clearSearchPaperTitle() {
        let obj = this;
        obj.searchPaperTitle = '';
        obj.rtnSearchPaperTitle = '';
        obj.showSearchBoardTitle = false;
        if(obj.page == 1) {
          obj.changeTableData = true;
        } else {
          obj.page = 1;
        }
        // obj.getListTabDashboardBoardList(null, false);
      },
      showBoardList(item, idx, _event) {      
         
        let obj = this;
        if(item != null && item != undefined) {
          if(_event != null && _event != undefined){
            obj.page = 1;
            obj.isReadFilter =false;
            obj.isBookmarkFilter =false;
            obj.searchPaperTitle = '';
            obj.rtnSearchPaperTitle = '';
            obj.showSearchBoardTitle = false;
            this.list.forEach((folObj, folIdx) => {
              let fObj = this.$refs['listFolder_' + folObj.category.categoryMid];
              if(fObj != null && fObj != undefined && fObj.length > 0) {
                if(fObj[0].classList.contains('active')) {
                  fObj[0].classList.toggle('active');
                }
                if(folObj.category.categoryMid == item.categoryMid) {
                  fObj[0].classList.toggle('active');
                }
              }
            }); 
            obj.selectedFolderIndex = idx;
            obj.selectedFolder = item;
            obj.getListTabDashboardBoardList(item, false); 
            this.setSelectedFolder(item);
          }
          else { 
            this.$nextTick(() => {
              if(this.$refs != null && this.$refs != undefined) {
                obj.isReadFilter =false;
                obj.isBookmarkFilter =false;
                obj.searchPaperTitle = '';
                obj.rtnSearchPaperTitle = '';
                obj.showSearchBoardTitle = false;
                this.list.forEach((folObj, folIdx) => {
                  let fObj = this.$refs['listFolder_' + folObj.category.categoryMid];
                  if(fObj != null && fObj != undefined && fObj.length > 0) {
                    if(fObj[0].classList.contains('active')) {
                      fObj[0].classList.toggle('active');
                    }
                    if(folObj.category.categoryMid == item.categoryMid) {
                      fObj[0].classList.toggle('active');
                    }
                  }
                });

              }
              obj.selectedFolderIndex = idx;
              obj.selectedFolder = item;
              
              obj.getListTabDashboardBoardList(item, false);

            });
          } 
        }
      },
      getListTabDashboardBoardList(folder, isSearch) {
        let obj = this;
        let pageParam = obj.page;
        //뒤로가기로 접근시 데이터 set
        if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
          window.sessionStorage.setItem("moveBoard",false);
          window.sessionStorage.setItem("prevBtn",false);
          let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          let state = stateArr[stateArr.length-1];
          
          let data ={
            categoryMid : state.categoryMid,
            projectId : state.projectId
          }
          folder = data;
          this.list.forEach((folObj, folIdx) => {
            let fObj = this.$refs['listFolder_' + folObj.category.categoryMid];
            if(fObj != null && fObj != undefined && fObj.length > 0) {
              if(fObj[0].classList.contains('active')) {
                fObj[0].classList.toggle('active');
              }
              if(folObj.category.categoryMid == state.categoryMid) {
                fObj[0].classList.toggle('active');
              }
            }
          });
          obj.selectedFolderIndex = state.selectedFolderIndex;

          //검색 설정 
          if(state.searchPaperTitle != ""){
            isSearch = true;
            this.isSearchArea = true;
            this.searchPaperTitle = state.searchPaperTitle;
          }
          
          //페이지 설정 
          if(pageParam != state.page){
            obj.page = state.page;
            return;
          }

          // 테이블 정렬 설정 
           
          obj.sortBy[0] = state.sortKey;
          obj.sortDesc[0] = state.sortDesc; 

          // 미확인보드보기, 즐겨찾기 보기 체크박스 설정
          obj.isBookmarkFilter = state.isBookmarkFilter;
          obj.isReadFilter = state.isReadFilter;

          //필터 유지.
          obj.gradeCodeList = state.gradeCodeList;
          obj.statusList = state.statusList;
          obj.initFilter = {
            gradeCodeList : state.gradeCheckYn == true ? obj.gradeCodeList : [],
            statusList : state.statusCheckYn == true ? obj.statusList : []
          }          
        }else{
          if(isSearch == true) {
            if(obj.searchPaperTitle == '') {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB091", "검색어를 입력해주세요.");
              obj.showToast(obj.toastInfo);
              return;
            }
            pageParam = 1;
          }
        }

        let selectedFolderInfo = folder || obj.selectedFolder;
        // let pageParam = obj.page;
        // if(isSearch == true) {
        //   if(obj.searchPaperTitle == '') {
        //     obj.toastInfo.message = obj.$i18nUtil.trans("TB091");
        //     obj.showToast(obj.toastInfo);
        //     return;
        //   }
        //   pageParam = 1;
        // }
        obj.boardList = [];
        if(obj.searchPaperTitle != null && obj.searchPaperTitle != undefined && obj.searchPaperTitle.length > 0) {
          obj.showSearchBoardTitle = true;
        } else {
          obj.showSearchBoardTitle = false;
        }
        obj.rtnSearchPaperTitle = obj.searchPaperTitle;
        obj.isProjectManager = false; 
        let param = {
          url: '/api/copaper/paper/getCategoryPaperList',
          method: 'post',
          req: {
            categoryMid : selectedFolderInfo.categoryMid, 
            projectId : selectedFolderInfo.projectId,
            searchPaperTitle: "%" + obj.searchPaperTitle + "%",
            limitRow: obj.itemsPerPage,
            page: pageParam - 1,
            sortKey: obj.sortBy[0],
            sortDesc: obj.sortDesc[0],
            isPaperBookmarkChecked: obj.isBookmarkFilter,
            isPaperReadChecked: obj.isReadFilter,
            gradeCodeList: obj.gradeCodeList,
            statusCodeList: obj.statusList,
          }
        };
        //프로그레스바 시작 

        // obj.showLoadingbar();
        obj.COWORK_REST_ACTION(param)
          .then(function (res) {
            //프로그레스바 종료
            // obj.hideLoadingbar();
            if(res.errorCode == null) {
              obj.boardList = res.result.paperList.content;
              obj.totalElements = res.result.paperList.totalElements;
              obj.pageCount = res.result.paperList.totalPages;
              obj.updUserList = [];
              obj.boardList.forEach(boardItem => {
                let isFlag = true;

                // if(obj.$i18nUtil.getLanguage() === 'ko') {

                // }else{
                //   boardItem.lastUpdUserName = boardItem.lastUpdUserNameEn != null ? boardItem.lastUpdUserNameEn : boardItem.lastUpdUserName;
                //   boardItem.lastModUserName = boardItem.lastModUserNameEn != null ? boardItem.lastModUserNameEn : boardItem.lastModUserName;
                //   boardItem.regUserName = boardItem.regUserNameEn != null ? boardItem.regUserNameEn : boardItem.regUserName;
                // }

                obj.updUserList.forEach(updUserItem => {
                  if(updUserItem.lastUpdUserId === boardItem.lastUpdUserId) {
                    isFlag = false;
                  }
                });
                if(isFlag) {
                  obj.updUserList.push(
                    {
                      lastUpdUserId: boardItem.lastUpdUserId
                    , lastUpdUserName: boardItem.lastUpdUserName
                    }
                  );
                  obj.updUserIds.push(boardItem.lastUpdUserId);
                }
              });
              obj.list.forEach(folderItemObj => {
                obj.folderIds.push(folderItemObj.category.categoryMid);
              });
              const sortingUpdUserList = obj.updUserList.sort((prevObj, newObj) => {
                var prevLastUpdUserName = prevObj.lastUpdUserName;
                var newLastUpdUserName = newObj.lastUpdUserName;
                if(prevLastUpdUserName < newLastUpdUserName) {
                  return -1;
                }
                if(prevLastUpdUserName > newLastUpdUserName) {
                  return 1;
                }
                // 같을 경우
                return 0;
              });
              obj.updUserList = sortingUpdUserList;
              obj.boardListFilter = obj.boardList;

              // 로그인 사용자가 운영자인지 링크를 건 사용자인지 확인하기 위함.
              if(obj.projectMemberList != null && obj.projectMemberList.length > 0) {
                obj.projectMemberList.forEach(mem => {
                  if(mem.userGrade && mem.userGrade == 'MANAGER' && mem.userId == obj.userId) {
                    obj.isProjectManager = true;
                  }
                });
              }

              // obj.setBoardFilter(); 
              // sessionStorage에 저장. 
              let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
              if(sessionState.length != 0){
                let lastState = sessionState.pop();
                lastState.categoryMid = selectedFolderInfo.categoryMid;
                lastState.projectId = selectedFolderInfo.projectId;
                lastState.searchPaperTitle = obj.searchPaperTitle;
                lastState.page = pageParam;
                lastState.isBookmarkFilter = obj.isBookmarkFilter;
                lastState.isReadFilter = obj.isReadFilter;
                lastState.sortDesc = obj.sortDesc[0];
                lastState.sortKey = obj.sortBy[0];
                lastState.limitRow = obj.itemsPerPage;
                lastState.selectedFolderIndex = obj.selectedFolderIndex;
                lastState.gradeCodeList = obj.gradeCodeList;
                lastState.statusList = obj.statusList;
                lastState.gradeCheckYn = obj.gradeCheckYn;
                lastState.statusCheckYn = obj.statusCheckYn;
                sessionState.push(lastState);
                window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
              }
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      filterCntOption(_event, type) {
        const targetLiElement = _event.target.parentElement;
        const ulElement = _event.target.parentElement.parentElement;
        if(ulElement != null && ulElement.children != null) {
          for (let ind = 0; ind < ulElement.children.length; ind++) {
            let liElement = ulElement.children[ind];
            if(liElement.classList.contains("active")) {
              liElement.classList.toggle("active");
            }
          }
        }
        targetLiElement.classList.toggle("active");
        let obj = this;
        obj.selectedCntOption = type;
        // obj.setBoardFilter();
      },
      filterEvaluationOption(_event, type) {
        const targetLiElement = _event.target.parentElement;
        const ulElement = _event.target.parentElement.parentElement;
        if(ulElement != null && ulElement.children != null) {
          for (let ind = 0; ind < ulElement.children.length; ind++) {
            let liElement = ulElement.children[ind];
            if(liElement.classList.contains("active")) {
              liElement.classList.toggle("active");
            }
          }
        }
        targetLiElement.classList.toggle("active");
        let obj = this;
        obj.selectedEvaluationOption = type;
        // obj.setBoardFilter();
      },
      filterPaperStatus(_event, paperStatus) {
        const targetLiElement = _event.target.parentElement;
        const ulElement = _event.target.parentElement.parentElement;
        if(ulElement != null && ulElement.children != null) {
          for (let ind = 0; ind < ulElement.children.length; ind++) {
            let liElement = ulElement.children[ind];
            if(liElement.classList.contains("active")) {
              liElement.classList.toggle("active");
            }
          }
        }
        targetLiElement.classList.toggle("active");
        let obj = this;
        obj.selectedPaperStatus = paperStatus;
        // obj.setBoardFilter();
      },
      fireFilterRead(){
        let obj = this;
        if(obj.page == 1) {
          obj.changeTableData = true;
        } else {
          obj.page = 1;
        }
        // obj.setBoardFilter();
      },
      fireFilterBookmark(){
        let obj = this;
        if(obj.page == 1) {
          obj.changeTableData = true;
        } else {
          obj.page = 1;
        }
        // obj.setBoardFilter();
      },
      updateCommonFilterE(filterData) {
        let obj = this;
        obj.gradeCodeList = filterData.filterGradeList;
        obj.statusList = filterData.filterStatusList;
        obj.gradeCheckYn = filterData.gradeCheckYn;
        obj.statusCheckYn = filterData.statusCheckYn;
        if(obj.page == 1) {
          obj.changeTableData = true;
        } else {
          obj.page = 1;
        }
      },
      selectAllUpdUser() {
        let obj = this;
        obj.updUserIds = [];
        if(!obj.allSelectedUpdUser) {
          for (const user in obj.updUserList) {
            obj.updUserIds.push(obj.updUserList[user].lastUpdUserId);
          }
        }
        // obj.setBoardFilter();
      },
      checkUpdUserFilter(e) {
        let obj = this;
        if(obj.updUserIds.length == obj.updUserList.length) {
          obj.allSelectedUpdUser = true;
        } else {
          obj.allSelectedUpdUser = false;
        }
        // obj.setBoardFilter();
      },
      selectAllFolder() {
        let obj = this;
        obj.folderIds = [];
        if(!obj.allSelectedFolder) {
          for (const folderObj in obj.list) {
            obj.folderIds.push(obj.list[folderObj].category.categoryMid);
          }
        }
        // obj.setBoardFilter();
      },
      checkFolderItemFilter(e) {
        let obj = this;
        if(obj.folderIds.length == obj.list.length) {
          obj.allSelectedFolder = true;
        } else {
          obj.allSelectedFolder = false;
        }
        // obj.setBoardFilter();
      },
      setBoardFilter() {
        let obj = this;
        obj.isSearchKeywordFlag = false;
        let useSearchKeywordFlag = false;
        // 미확인 보드 보기 필터링
        let readChecked = obj.isReadFilter;
        if(readChecked) {
          const result = obj.boardList.filter(function(board){
            return board.readCount == null || board.readCount == 0;
          });
          obj.boardListFilter = result;
          useSearchKeywordFlag = true;
        } else {
          obj.boardListFilter = obj.boardList;
        }
        // 즐겨찾기 필터링
        let bookmarkChecked = obj.isBookmarkFilter;
        if(bookmarkChecked) {
          const result = obj.boardListFilter.filter(function(board){
            return board.paperBookmarkId != null;
          });
          obj.boardListFilter = result;
          useSearchKeywordFlag = true;
        } else {
          obj.boardListFilter = obj.boardListFilter;
        }

        // 상세옵션 필터링
        if(obj.selectedCntOption == "MY") {
          const result = $.map(obj.boardListFilter, function(val, key) {
              if (val.regUserId == localStorage.getItem("userId")) 
                  return val;
          });
          obj.boardListFilter = result;
        } 
        else if(obj.selectedCntOption == "ALL") {
          obj.boardListFilter = obj.boardListFilter;
        }
        else if(obj.selectedCntOption == "MEMBER") {
          const result = obj.boardList.filter(function(board){
            return board.docGrade != "NORMAL";
          });
          obj.boardListFilter = result;
        }

        // 평가상태 필터링
        // let today = this.$moment().format('YYYYMMDD');
        // if(obj.selectedEvaluationOption == "ALL") {
        //   obj.boardListFilter = obj.boardListFilter;
        // } 
        // else if(obj.selectedEvaluationOption == 'GOOD') {
        //   const result = obj.boardListFilter.filter(function(board){ 
        //     return board.paperStatus == 'GOOD';
        //   }); 
        //   obj.boardListFilter = result; 
        // }
        // else if(obj.selectedEvaluationOption == 'SO') {
        //   const result = obj.boardListFilter.filter(function(board){ 
        //     return board.paperStatus == 'SO';
        //   }); 
        //   obj.boardListFilter = result;
        // }
        // else if(obj.selectedEvaluationOption == 'DELAY') {
        //   const result = obj.boardListFilter.filter(function(board){ 
        //     return board.paperStatus == 'DELAY';
        //   }); 
        //   obj.boardListFilter = result;
        // }
        // else if(obj.selectedEvaluationOption == 'EXCEEDED') {
        //   const result = obj.boardListFilter.filter(function(board){ 
        //     return board.paperStatus == 'EXCEEDED';
        //   }); 
        //   obj.boardListFilter = result;
        // }

        // 진행상태 필터링
        if(obj.selectedPaperStatus == "ALL") {
          obj.boardListFilter = obj.boardListFilter;
        } else {
          const result = obj.boardListFilter.filter(function(board){ 
            return board.paperStatus == obj.selectedPaperStatus;
          }); 
          obj.boardListFilter = result;
        }

        // 폴더 필터링
        if(obj.folderIds.length > 0) {
          const result = $.map(obj.boardListFilter, function(val, key) {
              if (obj.folderIds.includes(String(val.categoryMid))) 
                  return val;
          });
          obj.boardListFilter = result;
        } else {
          obj.boardListFilter = [];
        }
        
        // 생성/수정자 필터링
        if(obj.updUserIds.length > 0) {
          const result = $.map(obj.boardListFilter, function(val, key) {
              if (obj.updUserIds.includes(String(val.lastUpdUserId))) 
                  return val;
          });
          obj.boardListFilter = result;
        } else {
          obj.boardListFilter = [];
        }

        if(useSearchKeywordFlag) {
          obj.isSearchKeywordFlag = true;
        }
      },
      /* 정보공유 게시 */
      infoShareReqPost(board){
        if(board.checkPostYn == true) {
          this.toastInfo.message = this.$i18nUtil.trans("AB082", "사용 및 접근 권한이 없습니다.");
          this.showToast(this.toastInfo);
          return;
        }
        const modalInfo = {
          title: this.$i18nUtil.trans("title.ReqPostModal.shareInfo", "정보공유 게시"),
          name: "infoShareModal",
          method: "post",
          width: "800px",
          // height: "303px",
          obj: this.$modal,
          paperId: board.paperId,
          component: reqPost,
        };
        this.showModal(modalInfo);
      },
      /* 회의/협의 게시 */
      cooperationReqPost(board){
        if(board.checkPostYn == true) {
          this.toastInfo.message = this.$i18nUtil.trans("AB082", "사용 및 접근 권한이 없습니다.");
          this.showToast(this.toastInfo);
          return;
        }
        const modalInfo = {
          title: this.$i18nUtil.trans("title.ReqPostModal.cooperation", "회의/협의 게시"),
          name: "cooperationModal",
          method: "post",
          width: "800px",
          // height: "408px",
          obj: this.$modal,
          paperId: board.paperId,
          addfolderName:board.paperTitle,
          component: reqPost,
        };
        this.showModal(modalInfo);
      },
      /* 보드url 복사 */
      copyURL(text,board){
        if(board.checkUrlBoardFlag == true) {
          this.toastInfo.message = this.$i18nUtil.trans("AB082", "사용 및 접근 권한이 없습니다.");
          this.showToast(this.toastInfo);
          return;
        }
        let element = document.createElement("input");
        let s = element.style;
        s.border = "0";
        s.width = "1px";
        s.height = "1px";
        s.background = "#fff";
        s.color = "#fff";
        element.value = text+board.paperId;
        this.$el.appendChild(element);
        element.select();
        document.execCommand("copy");
        $(element).remove();
        this.toastInfo.message = this.$i18nUtil.trans('TB010', 'URL이 복사되었습니다.');
        this.showToast(this.toastInfo);
      },
      /* 현재 url */
      currentURL() {
        let url = window.location.href;
        let match = /^(.+)\/(dashboard)\/(PROJ[a-zA-Z0-9]+)/.exec(url);
        if (match.length > 3) {
          url = match[1] + "/board/";
        }
        return url;
      },
      /* 업무보드 복제 */
      copyPaperModal(board) {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.CopyBoardModal.001", "업무보드 복제"),
          name: "copyBoardModal",
          method: "post",
          width: "800px",
          // height: "516px",
          obj: this.$modal,
          paperId: board.paperId,
          groupId: board.groupId,
          component: CopyBoardModal,
        };
        this.showModal(modalInfo);
        
      },
      /* 보드삭제 */
      deleteBoard(board){
        let obj = this;
        obj.showConfirmDialogWithJSON({
          confirmMessage: obj.$i18nUtil.trans('AB001', '보드를 삭제할 경우 해당 보드에 등록된 파일과 내용이 모두 삭제되며 복구할 수 없습니다. 정말 삭제하시겠습니까?'),
          confirmBtnText: obj.$i18nUtil.trans("button.dialog.delete", "삭제"),
          confirmBtnCallback: obj.deletePaperApiCall,
          modalParam: {board: board},
          cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
        });
      },
      deletePaperApiCall(callbackData) {
        let obj = this;
        let reqData = {};
        reqData.params ={
          paperId : callbackData.modalParam.board.paperId,
          groupId : callbackData.modalParam.board.groupId,
          categoryMid : callbackData.modalParam.board.categoryMid,
          deleteYn :"1"
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/paper/deletePaper";
        reqData.method = "post";
        obj.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            obj.hideLoadingbar();
            if(res.fncAuthRst != null) {
                // 삭제 권한이 없을 경우
                if(!res.fncAuthRst.allow) {
                    obj.toastInfo.message = obj.$i18nUtil.trans('TB056', '삭제 권한이 없습니다.');
                    obj.showToast(obj.toastInfo);
                    return;
                }
            }
            obj.toastInfo.message = obj.$i18nUtil.trans('TB027', '보드가 삭제되었습니다.');
            obj.showToast(obj.toastInfo);
            const idx = obj.boardList.findIndex(function(data) {
              return data.paperId == callbackData.modalParam.board.paperId;
            });
            obj.boardList.splice(idx,1);
            const index = obj.boardListFilter.findIndex(function(data) {
              return data.paperId == callbackData.modalParam.board.paperId;
            });
            // obj.setBoardFilter();  
            let paperCount = this.selectedFolder.paperCount; 
            this.selectedFolder.paperCount = (paperCount -1 ) > 0 ? (paperCount-1) : 0; 
          })
          .catch(function(err) {
            console.log(err);
          });
      },
      /* Linked 연결 해제 */
      unlinkedProject(board){
        let obj = this;
        obj.showConfirmDialogWithJSON({
          confirmMessage: obj.$i18nUtil.trans('AB068', 'Linked 보드 연결을 해제하시겠습니까?'),
          confirmBtnText: obj.$i18nUtil.trans("button.dialog.unlink", "해제"),
          confirmBtnCallback: obj.unlinkedProjectApiCall,
          modalParam: {board: board},
          cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
        });
      },
      unlinkedProjectApiCall(callbackData) {
        let obj = this;
        let saveUrl = "/api/copaper/paperlink/saveBoardLinkProject";
        let param = {
            paperProjectLinkId: callbackData.modalParam.board.paperProjectLinkId,
            paperId: callbackData.modalParam.board.paperId,
            projectId: callbackData.modalParam.board.projectId,
            groupId: callbackData.modalParam.board.groupId,
            categoryMid: callbackData.modalParam.board.categoryMid,
        };
        // obj.showLoadingbar();
        axios
            .post(saveUrl, param)
            .then((res) => {
                // obj.hideLoadingbar();
                if (res.data.errorCode != null && res.data.errorCode != undefined) {
                    console.log('saveBoardLinkProject error', res.data.errorCode);
                    return;
                }
                obj.toastInfo.message = obj.$i18nUtil.trans('TB081', '연결이 해제되었습니다.');
                obj.showToast(obj.toastInfo);
                obj.selectedFolder.paperCount = obj.selectedFolder == null ? 0 : (Number(obj.selectedFolder.paperCount) - 1);
                const idx = obj.boardList.findIndex(function(data) {
                  return data.paperId == callbackData.modalParam.board.paperId;
                });
                obj.boardList.splice(idx,1);
                const index = obj.boardListFilter.findIndex(function(data) {
                  return data.paperId == callbackData.modalParam.board.paperId;
                });
                // obj.setBoardFilter();
            })
            .catch((err) => {
                obj.hideLoadingbar();
                console.log("axios err => ", err);
            });
      },
      /* 즐겨찾기 설정/해제 */
      toggleBookmark(board) {
        let obj = this;
        let reqData = {};
        reqData.params ={
          paperId: board.paperId,
          bookmarkId:board.paperBookmarkId
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/bookmark/savePaperBookmark";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            board.paperBookmarkId = res.result;
            if(board.paperBookmarkId != null) {
              obj.toastInfo.message = obj.$i18nUtil.trans('TB041', '즐겨찾기가 설정되었습니다.');
              obj.showToast(obj.toastInfo);
            } 
            else {
              obj.toastInfo.message = obj.$i18nUtil.trans('TB042', '즐겨찾기가 해제되었습니다.');
              obj.showToast(obj.toastInfo);
            }
            obj.changeTableData = true;
          }) 
          .catch(function(err) {
            console.log(err);
          });
      },
      goBoard(board) {
        window.sessionStorage.setItem("moveBoard",true); 
        let postPath = board.paperProjectLinkId == null ? (board.paperId) :  (board.paperId+"/"+board.paperProjectLinkId); 
        let path = "/general/board/" + postPath;
        this.$router.push(path);
      },
      moveProject(linkProjectId){
        let path = "/general/dashboard/" + linkProjectId;
        this.$router.push(path);
      },
      getEvaluateClassAndText(board) {
        let rtnEvaluateJson = {evaluateClass: '', evaluateText: ''};
        // exceeded
        if(board.paperStatus == 'GOOD') {
          rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-good";
          rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상");
        }
        // on track
        else if(board.paperStatus == 'SO') {
          rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-so";
          rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생");
        }
        // at risk
        else if(board.paperStatus == 'DELAY') {
          rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-delay";
          rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요");
        }
        // off track
        else if(board.paperStatus == 'EXCEEDED') {
          rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-exceeded";
          rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료");
        }
        return rtnEvaluateJson;
      },
      checkHours(lastUpdated) {
        let now = this.$moment()
        let before24hours = this.$moment().subtract(1,'days')
        let lastUpdatedTime = this.$moment(lastUpdated)
        
        if(lastUpdatedTime.isBetween(before24hours, now)) {
          // 24시간 이내
          return true;
        }else{
          // 24시간 이후
          return false;
        }
      },
      deleteFolder(item,idx){
        // event.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');
        if(this.list.length < 2){
          this.showAlertDialog(this.$i18nUtil.trans("AB032", "등록된 과정이 1개 이하인 경우 삭제할 수 없습니다."), null, {width: "400px"});
          return;
        }else if ( item.category.paperCount != 0 && this.userInfo.userGrade != "MANAGER"){
          //운영자가 아니고 하위에 보드가 존재
          this.showAlertDialog(this.$i18nUtil.trans("AB031", "과정 내 보드가 있으면 과정 삭제 불가합니다."), null, {
            width: "400px",
            // height: "148px",
          });
          return;
        }else{
          let obj=  this;
          let modalInfo = {
              name: "deleteFolder",
              width: "400px", 
              obj: obj.$modal,
              title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
              contents: obj.$i18nUtil.trans("message.BoardList.004", "삭제 시 해당 과정 하위의 보드가 모두 삭제됩니다.")
                        +"<br/>"+obj.$i18nUtil.trans("message.BoardList.005", "정말 삭제하시겠습니까?"),
              btnName: obj.$i18nUtil.trans("button.delete", "삭제"), 
              item:item,
              idx:idx,
              // parentCategory :"e",
              component: ConfirmModal
          }; 
          obj.showModal(modalInfo); 
        }

       /*  if(item.paperCount == 0 ){
            let result = confirm("삭제하시겠습니까?");
            if(result){
              let param = {
                item:item,
                idx:idx
              } 
              this.$emit("delete-category",param,parentCategory);
            }
          }else{
            alert("업무보드가 존재합니다. ");
          } */
      },
      updateFolderName(item){
        let obj = this;
        const modalInfo = {
          title: this.$i18nUtil.trans("title.RegistCategoryModal.002", "과정명 변경"),
          name: "updateFolderName",
          method: "post",
          // width: "500px",
          // height: "300px",
          width: "800px",
          obj: obj.$modal, 
          category: item,
          component: RegistCategoryModal,  
        };
        obj.showModal(modalInfo);
      },
      registFolder(){
        // event.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');
       
        let obj = this;
        const modalInfo = {
          title: this.$i18nUtil.trans("title.RegistCategoryModal.001", "과정 추가"),
          name: "registFolder",
          method: "post",
          // width: "500px",
          // height: "300px",
          width: "800px",
          obj: obj.$modal,  
          groupId: this.categoryListInfo.groupId,
          component: RegistCategoryModal,
          parentCategoryMid: this.parentCategoryMid,
          projectId: this.categoryListInfo.projectId,
          regUserId: this.categoryListInfo.regUserId,  
        };
        obj.showModal(modalInfo);
      },
      getClassName(item){
        if(item.categoryStatus === "Y"){
          return "ico-txt-evaluate-so";
        }else if(item.categoryStatus === "G"){
          return "ico-txt-evaluate-good";
        }else if(item.categoryStatus === "R"){
          return "ico-txt-evaluate-delay";
        } 
      },
      getPaperUserList(item, _event) {
        if(_event.target.parentElement.classList != null && _event.target.parentElement.classList.contains("active")) {
          _event.target.parentElement.classList.toggle("active");
          return;
        }
        let obj = this;
        let url = "/api/copaper/paperuser/getPaperUserList";
        let param = {};
        param = {
          paperId: item.paperId,
        };
        axios
          .post(url, param)
          .then(res => {
            if (res.data.errorCode != null) {
              return;
            }
            Vue.set(item, "paperUserList", res.data.result.userList);
            Vue.set(item, "paperUserCount", res.data.result.userList == null ? 0 : res.data.result.userList.length);
            _event.target.parentElement.classList.toggle('active');
          })
          .catch(err => {
            console.log("axios err => ", err);
          });
      },
      replaceAll(str, input, output) {
        return str.split(input).join(output);
      },
      checkManager(item){  
        if(this.userInfo == null ){
          return false;
        }else{
          return item.category.regUserId == this.userInfo.userId || this.userInfo.userGrade == "MANAGER";
        }
      },

    }
}
</script> 

<style scoped>
.task-list .card_grp.active:after, :before{
      box-sizing: inherit; 
}
.tb-contents.ins002a td .ell-singleline {width: calc(100% - 85px); max-width: 350px;}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/list/DashboardList.vue